var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.users && _vm.users.length > 0)?_c('div',{staticClass:"avatars"},_vm._l((_vm.users),function(user){return _c('avatar',{key:user.id,attrs:{"user":user}})}),1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }